"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/tag/tag-context.tsx
var _react = require('react');
var TagValueContext = _react.createContext.call(void 0, null);
var TagRemoveIdContext = _react.createContext.call(void 0, 
  null
);
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useTagContext = ctx.useContext;
var useTagScopedContext = ctx.useScopedContext;
var useTagProviderContext = ctx.useProviderContext;
var TagContextProvider = ctx.ContextProvider;
var TagScopedContextProvider = ctx.ScopedContextProvider;









exports.TagValueContext = TagValueContext; exports.TagRemoveIdContext = TagRemoveIdContext; exports.useTagContext = useTagContext; exports.useTagScopedContext = useTagScopedContext; exports.useTagProviderContext = useTagProviderContext; exports.TagContextProvider = TagContextProvider; exports.TagScopedContextProvider = TagScopedContextProvider;
